<div *ngIf="user" class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-white tw-border tw-border-[#E8E8E8] tw-rounded-[10px] md:tw-px-4 lg:tw-px-8">
  <form class="tw-w-full tw-h-fit tw-py-8 tw-px-4" [formGroup]="formGroup">
    <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-4 tw-mb-8">
      <p class="tw-flex-1 tw-font-poppins tw-font-bold tw-text-lg tw-text-secondary">
        {{ title | translate }}
      </p>
      <div (click)="closeModal()" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full tw-cursor-pointer">
        <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-light-icon.svg" />
      </div>
    </div>
    <app-input [formGroup]="formGroup" formControlName="name" [label]="'name' | translate"></app-input>
    <app-phone-input [formGroup]="formGroup" formControlName="phone" [label]="'phone' | translate" [selectedCountryISO]="selectedCountryISO"></app-phone-input>

    <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "location" | translate }}</p>
    <div class="tw-w-full tw-h-52 tw-relative tw-overflow-hidden tw-rounded-[10px] tw-mb-6">
      <div id="map" class="tw-w-full tw-h-full !tw-z-[1]"></div>
      <button
        (click)="getUserLocation(false)"
        class="tw-w-fit tw-h-fit tw-absolute tw-bottom-8 tw-right-4 !tw-z-[99] tw-bg-tertiary hover:tw-bg-tertiary/90 active:tw-bg-tertiary/80 tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border tw-border-primary hover:tw-border-primary/80 tw-rounded-[5px] tw-px-2 tw-py-2 tw-shadow-lg hover:tw-shadow-xl active:tw-shadow-md tw-transition-all tw-duration-200 hover:tw-scale-105 active:tw-scale-95"
      >
        <img class="tw-w-6 tw-h-6 tw-object-contain tw-filter tw-drop-shadow-sm" src="../../../assets/user-location-marker.svg" />
      </button>
    </div>

    <div class="tw-w-full tw-h-fit tw-flex tw-flex-col md:tw-flex-row tw-gap-2">
      <app-input class="tw-flex-1 tw-max-w-full" [formGroup]="formGroup" formControlName="start_hour" [label]="'start-hour' | translate" type="time"></app-input>
      <app-input class="tw-flex-1 tw-max-w-full" [formGroup]="formGroup" formControlName="end_hour" [label]="'end-hour' | translate" type="time"></app-input>
    </div>

    <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "off-days" | translate }}</p>
      <p-multiSelect
        class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
        [options]="weekdays"
        formControlName="off_days"
        [filter]="false"
        [showClear]="true"
        [placeholder]="'off-days' | translate"
        (onChange)="setOffDays($event)"
        (onClear)="clearOffDays()"
        optionLabel="name"
        dataKey="id"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ item.name }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>

    <div *ngIf="user.user.business.type == accountTypes.Delivery" class="tw-w-full tw-h-fit">
      <app-toggle
        [formGroup]="formGroup"
        formControlName="own_branch"
        [label]="'branch-type' | translate"
        [negative]="{ label: 'my-branch', value: 'my-branch' }"
        [positive]="{ label: 'external-branch', value: 'external-branch' }"
      ></app-toggle>

      <div *ngIf="formGroup.get('own_branch').value == 'external-branch'" class="full-dropdown tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "business" | translate }}</p>
        <p-dropdown
          class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="businesses"
          [(ngModel)]="selectedBusiness"
          [ngModelOptions]="{ standalone: true }"
          dataKey="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [placeholder]="'business' | translate"
          (onFilter)="searchBusinesses.next($event.filter)"
          [emptyFilterMessage]="searchBusinessesNoResults | translate"
          (onChange)="setBusiness($event)"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ item.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <div *ngIf="formGroup.get('own_branch').value == 'external-branch'" class="full-dropdown tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "parent-branch" | translate }}</p>
        <p-dropdown
          class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="branches"
          [(ngModel)]="selectedBranch"
          [ngModelOptions]="{ standalone: true }"
          dataKey="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [placeholder]="'parent-branch' | translate"
          (onFilter)="searchBranches.next($event.filter)"
          [emptyFilterMessage]="searchBranchesNoResults | translate"
          (onChange)="setBranch($event)"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ item.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>

    <app-toggle
      *ngIf="user.user.business.type == accountTypes.Merchant"
      [formGroup]="formGroup"
      formControlName="delivery_type"
      [label]="'delivery-type' | translate"
      [negative]="{ label: 'team', value: 'team' }"
      [positive]="{ label: '3rd-party', value: '3rd-party' }"
    ></app-toggle>

    <div *ngIf="user.user.business.type == accountTypes.Merchant && formGroup.get('delivery_type').value == '3rd-party'" class="full-dropdown tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
      <p-dropdown
        class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
        [options]="thirdParties"
        [(ngModel)]="selectedThirdParty"
        [ngModelOptions]="{ standalone: true }"
        dataKey="id"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [placeholder]="'3rd-party' | translate"
        (onFilter)="searchThirdParties.next($event.filter)"
        [emptyFilterMessage]="searchThirdPartiesNoResults | translate"
        (onChange)="setThirdParty($event)"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ item.name }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div
      *ngIf="
        (user.user.business.type == accountTypes.Delivery && formGroup.get('own_branch').value == 'my-branch') ||
        (user.user.business.type == accountTypes.Merchant && formGroup.get('delivery_type').value == 'team')
      "
      class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4"
    >
      <p-multiSelect
        class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
        [options]="teamMembers"
        [(ngModel)]="selectedTeamMembers"
        [ngModelOptions]="{ standalone: true }"
        dataKey="id"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        [placeholder]="'team-members' | translate"
        (onFilter)="searchTeamMembers.next($event.filter)"
        [emptyFilterMessage]="searchTeamMembersNoResults | translate"
        (onChange)="setTeamMembers($event)"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.name }}</div>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ item.name }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>

    <app-input [formGroup]="formGroup" formControlName="delivery_radius" [label]="'delivery-radius' | translate" type="number"></app-input>

    <div class="tw-w-full tw-h-fit tw-flex tw-flex-col md:tw-flex-row tw-gap-2">
      <app-input class="tw-flex-1 tw-max-w-full tw-min-w-0" [formGroup]="formGroup" formControlName="eta_min" [label]="'eta-min' | translate" type="number"></app-input>
      <app-input class="tw-flex-1 tw-max-w-full tw-min-w-0" [formGroup]="formGroup" formControlName="eta_max" [label]="'eta-max' | translate" type="number"></app-input>
    </div>

    <app-input [formGroup]="formGroup" formControlName="shipping_cost" [label]="'shipping-cost' | translate" type="number"></app-input>

    <app-input [formGroup]="formGroup" formControlName="min_order" [label]="'min-order' | translate" type="number"></app-input>

    <div class="tw-w-full tw-h-2"></div>
    <app-button [disabled]="disableButton" [text]="'save' | translate" [fullWidth]="true" [onButtonClick]="buttonClicked.bind(this)"></app-button>
  </form>
</div>
